import { render, staticRenderFns } from "./orgBgmRelationQueryAction.vue?vue&type=template&id=289db836&scoped=true"
import script from "./orgBgmRelationQueryAction.vue?vue&type=script&lang=js"
export * from "./orgBgmRelationQueryAction.vue?vue&type=script&lang=js"
import style0 from "./orgBgmRelationQueryAction.vue?vue&type=style&index=0&id=289db836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289db836",
  null
  
)

export default component.exports